var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmptyFile = function SvgEmptyFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00004 1.96004C1.98943 1.96004 1.97926 1.96425 1.97176 1.97176C1.96425 1.97926 1.96004 1.98943 1.96004 2.00004V24C1.96004 24.0106 1.96425 24.0208 1.97176 24.0283C1.97926 24.0358 1.98943 24.04 2.00004 24.04H20C20.0107 24.04 20.0208 24.0358 20.0283 24.0283C20.0358 24.0208 20.04 24.0107 20.04 24V8.39768L13.6024 1.96004H2.00004ZM0.61411 0.61411C0.981681 0.246539 1.48021 0.0400391 2.00004 0.0400391H14C14.2546 0.0400391 14.4988 0.141182 14.6789 0.321217L21.6789 7.32122C21.8589 7.50125 21.96 7.74543 21.96 8.00004V24C21.96 24.5199 21.7535 25.0184 21.386 25.386C21.0184 25.7535 20.5199 25.96 20 25.96H2.00004C1.48022 25.96 0.981683 25.7535 0.61411 25.386C0.246538 25.0184 0.0400391 24.5199 0.0400391 24V2.00004C0.0400391 1.48021 0.246539 0.981681 0.61411 0.61411Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0.0400391C14.5302 0.0400391 14.96 0.469846 14.96 1.00004V7.04004H21C21.5302 7.04004 21.96 7.46985 21.96 8.00004C21.96 8.53023 21.5302 8.96004 21 8.96004H14C13.4698 8.96004 13.04 8.53023 13.04 8.00004V1.00004C13.04 0.469846 13.4698 0.0400391 14 0.0400391Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04004 14C6.04004 13.4698 6.46985 13.04 7.00004 13.04H15C15.5302 13.04 15.96 13.4698 15.96 14C15.96 14.5302 15.5302 14.96 15 14.96H7.00004C6.46985 14.96 6.04004 14.5302 6.04004 14Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04004 18C6.04004 17.4698 6.46985 17.04 7.00004 17.04H15C15.5302 17.04 15.96 17.4698 15.96 18C15.96 18.5302 15.5302 18.96 15 18.96H7.00004C6.46985 18.96 6.04004 18.5302 6.04004 18Z",
    fill: "#666666"
  })));
};
export default SvgEmptyFile;